import type { AdminRole, PortalView } from "../types";
import type { Route } from "./routing";

export function canManageTemplates(role: AdminRole): boolean {
  return role === "superAdmin" || role === "cardTemplateCreator";
}

export function roleLabel(role: AdminRole | null): string {
  if (role === "cardTemplateCreator") return "Card Template Creator";
  if (role === "superAdmin") return "Super admin";
  return role ? "Read only" : "Invalid";
}

export function canAccessView(role: AdminRole, view: PortalView): boolean {
  return role !== "cardTemplateCreator" || view === "card-templates";
}

export function routeForRole(route: Route, role?: AdminRole): Route {
  return role && !canAccessView(role, route.view) ? { view: "card-templates", customerGuid: null } : route;
}
